import { SubmissionError } from 'redux-form/immutable';
import { replace } from 'react-router-redux';

import sessionApi from '../api/sessionApi';

export const signUp = user =>
  dispatch =>
    sessionApi.signUp({ user }).then(() => {
      dispatch(replace('/registro-exito'));
    }).catch((err) => {
      throw new SubmissionError(err.errors);
    });



// WEBPACK FOOTER //
// ./src/actions/signUpActions.js